import {
  FieldArray,
  FieldValues,
  Path,
  UseFieldArrayReturn,
  UseFormReturn
} from 'react-hook-form';
import {
  Button,
  Flex,
  Icon,
  IconButton,
  IconName,
  Input,
  InputProps
} from '../../atoms';

type Props<T extends FieldValues> = {
  name: string;
  fieldKey: string;
  addLabel?: string;
  ref?: React.Ref<HTMLInputElement>;
} & Pick<UseFormReturn<T>, 'register'> &
  Pick<UseFieldArrayReturn<T>, 'append' | 'fields' | 'remove'> &
  InputProps;

//This one is heavlily linked with react hook form and for only one field at the time
//Improve version is already planned

export function RHFArrayField<T extends FieldValues>({
  name,
  fieldKey,
  fields,
  register,
  append,
  remove,
  addLabel,
  isDisabled,
  isRequired,
  size,
  ...rest
}: Props<T>): JSX.Element {
  return (
    <>
      {fields.map((field, index) => (
        <Flex
          key={field.id}
          marginTop="space_unit.x1"
          justifyContent="space-between"
          alignItems="center"
        >
          <Input
            w="80%"
            key={field.id}
            isDisabled={isDisabled}
            isRequired={isRequired}
            {...rest}
            {...register(`${name}.${index}.${fieldKey}` as Path<T>, {
              required: isRequired
            })}
          />
          {((isRequired && fields.length > 1) || !isRequired) && (
            <IconButton
              variant="secondary"
              marginLeft="space_unit.x4"
              aria-label="delete input"
              icon={<Icon name={IconName.Trash} />}
              onClick={(): void => remove(index)}
              w="space_unit.x4"
              h="space_unit.x4"
              borderRadius="radii.x2"
              isDisabled={isDisabled}
            />
          )}
        </Flex>
      ))}
      <Button
        isDisabled={isDisabled}
        size={size}
        variant="secondary"
        flexGrow={1}
        leftIcon={<Icon h="28px" w="28px" name={IconName.Plus} />}
        marginTop="space_unit.x2"
        onClick={(): void => append({ [fieldKey]: '' } as FieldArray<T>)}
        data-testid="btn-add"
      >
        {addLabel || 'ADD'}
      </Button>
    </>
  );
}
